
import { Check, X } from "lucide-react";

interface PasswordCriteria {
  length: boolean;
  uppercase: boolean;
  lowercase: boolean;
  number: boolean;
  special: boolean;
}

interface PasswordStrengthIndicatorProps {
  password: string;
}

export default function PasswordStrengthIndicator({ password }: PasswordStrengthIndicatorProps) {
  const checkPasswordCriteria = (password: string): PasswordCriteria => {
    return {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /[0-9]/.test(password),
      special: /[^A-Za-z0-9]/.test(password)
    };
  };

  const criteria = checkPasswordCriteria(password);

  return (
    <div className="bg-gray-50 p-3 rounded-md border border-gray-200 dark:bg-gray-800 dark:border-gray-700">
      <p className="text-sm font-medium mb-2">Password requirements:</p>
      <ul className="space-y-1 text-sm">
        <li className="flex items-center">
          {criteria.length ? 
            <Check className="h-4 w-4 text-green-500 mr-2" /> : 
            <X className="h-4 w-4 text-red-500 mr-2" />}
          At least 8 characters
        </li>
        <li className="flex items-center">
          {criteria.uppercase ? 
            <Check className="h-4 w-4 text-green-500 mr-2" /> : 
            <X className="h-4 w-4 text-red-500 mr-2" />}
          One uppercase letter
        </li>
        <li className="flex items-center">
          {criteria.lowercase ? 
            <Check className="h-4 w-4 text-green-500 mr-2" /> : 
            <X className="h-4 w-4 text-red-500 mr-2" />}
          One lowercase letter
        </li>
        <li className="flex items-center">
          {criteria.number ? 
            <Check className="h-4 w-4 text-green-500 mr-2" /> : 
            <X className="h-4 w-4 text-red-500 mr-2" />}
          One number
        </li>
        <li className="flex items-center">
          {criteria.special ? 
            <Check className="h-4 w-4 text-green-500 mr-2" /> : 
            <X className="h-4 w-4 text-red-500 mr-2" />}
          One special character
        </li>
      </ul>
    </div>
  );
}
